// @ts-nocheck
import { measureApi, timeZoneApi } from '@/api/config-setup'
import Select from '@/components/form-control/Select'
import { ADMIN_ROUTES, OPERATIONS_ROUTES } from '@/constant/route'
import useUpdateUserProfile from '@/features/auth/hooks/useUpdateUser'
import useUser from '@/features/auth/hooks/useUser'
import { NotifyService, setupHelper } from '@/helpers'
import { changeTheme } from '@/store/slices/themeSlice'
import { DATA_PAGINATION, OptionItem } from '@/types'
import { User } from '@/types/user'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Stack, Typography } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'

type Props = {}

interface FormInputs {
  measure: OptionItem
  timeZone: OptionItem
}

const defaultValues: Partial<FormInputs> = {
  measure: undefined,
  timeZone: undefined,
}

const LayoutCenter = (props: Props) => {
  const navigate = useNavigate()
  const { data: user } = useUser<User>()
  const updateProfile = useUpdateUserProfile()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(changeTheme('dark'))
  }, [])

  const schema = useMemo(() => {
    return yup
      .object({
        measure: yup.mixed().required('Unit of Measurement is required'),
      })
      .required()
  }, [])

  const form = useForm<FormInputs>({
    defaultValues: defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  })

  const { handleSubmit, reset } = form

  useEffect(() => {
    if (!user) return
    if (
      setupHelper.isDoneAccountConfig(user) &&
      (user.role === 'SuperAdmin' || user.role === 'Admin')
    ) {
      navigate(ADMIN_ROUTES.index.to)
      return
    }

    if (
      setupHelper.isDoneAccountConfig(user) &&
      (user.role === 'Manager' || user.role === 'User')
    ) {
      navigate(OPERATIONS_ROUTES.index.to)
      return
    }
    reset({
      measure: user.measure
        ? { id: user.measure.id, name: user.measure.name }
        : undefined,
      timeZone: user.gmtTimeZone
        ? {
            id: user.gmtTimeZone.id,
            zoneId: user.gmtTimeZone.zoneId,
            description: user.gmtTimeZone.displayName,
          }
        : undefined,
    })
  }, [user, reset, navigate])

  const onSubmit = async (data: FormInputs) => {
    updateProfile({
      gmtTimeZoneId: 273,
      measureId: data.measure.id,
    })
  }

  const getOptions = (key: keyof FormInputs) => async () => {
    let data: DATA_PAGINATION | undefined
    switch (key) {
      case 'measure':
        data = await measureApi
          .getAll()
          .then(({ data }) => ({
            data: data,
            page: 1,
            size: data.length,
            totalCount: data.length,
            totalPage: 1,
          }))
          .catch((e) => {
            NotifyService.error(e)
            return undefined
          })
        break
      case 'timeZone':
        data = await timeZoneApi
          .getAll()
          .then(({ data }) => ({
            data: data,
            page: 1,
            size: data.length,
            totalCount: data.length,
            totalPage: 1,
          }))
          .catch((e) => {
            NotifyService.error(e)
            return undefined
          })
        break
    }
    return data
  }

  return (
    <Stack
      sx={{ mt: '52px' }}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Stack sx={{ alignItems: 'center' }}>
        <Typography sx={{ fontSize: '20px', lineHeight: '2.4' }}>
          Account Configurations
        </Typography>
      </Stack>

      <Stack>
        <Select
          label="Unit of Measurement"
          name="measure"
          bindLabel="name"
          form={form}
          getOptions={getOptions('measure')}
        />
      </Stack>

      <Stack direction="row" justifyContent="space-between" sx={{ mt: '16px' }}>
        <Stack justifyContent="center">
          <Typography sx={{ fontSize: '13px', color: '#5C5C5C' }}>
            These settings can be changed later
          </Typography>
        </Stack>
        <Button
          type="submit"
          sx={{
            borderRadius: '4px',
            maxHeight: '26px',
            width: '72px',
            textDecoration: 'none',
          }}
        >
          Save
        </Button>
      </Stack>
    </Stack>
  )
}

export default LayoutCenter
